// A stand-in for the merchant's website, built in memory and opened as a blob so
// there is no page to host. It runs on the dashboard's origin rather than the
// API's, which means it exercises the same cross-origin request a real merchant
// site would.

const STYLES = `
      body { margin: 0; font: 16px/1.6 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; color: #1f2937; background: #f6f5f3; }
      .banner { background: #111827; color: #fff; padding: .7rem 1.25rem; font-size: .8125rem; }
      .banner b { font-weight: 600; }
      header { background: #fff; border-bottom: 1px solid #e5e7eb; padding: 2.5rem 1.25rem; }
      header .inner, main { max-width: 44rem; margin: 0 auto; }
      header h1 { margin: 0; font-size: 1.75rem; letter-spacing: -.02em; }
      header p { margin: .4rem 0 0; color: #6b7280; }
      main { padding: 2.5rem 1.25rem 5rem; }
      .card { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 1.75rem; }
      .card h2 { margin: 0 0 .25rem; font-size: 1.125rem; }
      .card > p { margin: 0 0 1.25rem; color: #6b7280; font-size: .9375rem; }
      .card + .card { margin-top: 1.5rem; }
      .box { height: 600px; outline: 1px dashed #d1d5db; outline-offset: 8px; border-radius: 2px; }`

// Heading and blurb are optional: a form that already says what it is needs no
// page copy repeating it back.
export const testPageCard = (heading, blurb, content) => `
      <div class="card">${
        heading
          ? `
        <h2>${heading}</h2>`
          : ''
      }${
        blurb
          ? `
        <p>${blurb}</p>`
          : ''
      }
        ${content}
      </div>`

export const testPageDocument = ({ body, blurb, strapline }) => `<!doctype html>
<html lang="en">
  <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Example page</title>
    <style>${STYLES}
    </style>
  </head>
  <body>
    <div class="banner"><b>Example page.</b> Stands in for the merchant's website - ${blurb}</div>
    <header><div class="inner"><h1>Your website</h1><p>${strapline}</p></div></header>
    <main>${body}
    </main>
  </body>
</html>`

// The form twice over - free-standing, then inside a fixed-height box - because
// the thing merchants get wrong is the container, not the paste.
export const formTestBody = ({ snippet, heading = '', blurb = '' }) =>
  testPageCard(heading, blurb, snippet) +
  testPageCard(
    'In a 600px box',
    'The same form in a container 600px tall. The questions scroll and the title stays put.',
    `<div class="box">${snippet}</div>`
  )

export const openTestPage = document => {
  const url = URL.createObjectURL(new Blob([document], { type: 'text/html' }))
  window.open(url, '_blank')
  // Revoked on a delay: the new tab needs the URL to still resolve while it loads.
  setTimeout(() => URL.revokeObjectURL(url), 60000)
}
